import React, { useEffect, useState } from 'react'
import ContentContainer from '../../components/ContentContainer'
import useCompanyParam from '../../hooks/CompanyParam'
import ApiEndpoint, { ApiResponse } from '../../network/ApiEndpoint'
import BroadcastThumbnail from 'components/cards/BroadcastThumbnail'
import { mapBroadcastThumbnailResponse } from '../../api/channel/mapBroadcastThumnbailFromResponse'
import { useSelector } from 'react-redux'
import { channelSelector } from 'redux-store/channel/channel.selectors'
import LoadMoreSection from 'components/LoadMoreSection/LoadMoreSection'

const FeedPage = () => {
  const [ page, setPage ] = useState(1)
  const [totalPages, setTotalPages] = useState<any>(1)
  const company = useCompanyParam()
  const channel = useSelector(channelSelector)
  const getFeed = async (parameters: {}): Promise<any> => {
    try {
      const response: ApiResponse = await ApiEndpoint.call({
        path: 'session/user_feed',
        params: parameters
      })
      try {
        setTotalPages(response.totalCount || 1 / 40)
      } catch(e: any){}
      const mapped = mapBroadcastThumbnailResponse(response.data, channel)
      return mapped
    } catch (e: any) {
      // @ts-ignore
      throw new Error(e.message)
    }
  }

  const [ data, setData ]: any = useState([])

  useEffect(() => {
    if (company && channel.data) {
      const opts: any = {
        page: page,
        per_page: 40
      }
      if (channel.data.isRootChannel) {
        opts['company'] = company
      } else {
        opts['country_code'] = channel.data.country.code
        opts['sport'] = channel.data.category.translated_name
      }
      getFeed(opts).then((response) => {
        setData([...data, ...response ])
      })
    }
  }, [company, page, channel])

  return (
    <ContentContainer
      hasLeftRightPadding={true}
      hasTopBottomPadding={true}
      hasLightBackground={true}
    >
      <h3 style={{marginBottom: 20}}>Feed (beta)</h3>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between'
        }}
      >
        {data &&
          data.map((card: any, index: number) => (
            <div key={`${card.id}-${index}`} style={{ marginBottom: '20px' }}>
              <BroadcastThumbnail
                key={`${card.id}-${index}`}
                content={card}
                shared={false}
                size="small"
                showDetails
                disableLink={false}
              />
            </div>
          ))}
      </div>
      <LoadMoreSection
        currentPage={page}
        onClick={() => setPage(page + 1)}
        totalPages={totalPages}
      />
    </ContentContainer>
  )
}

export default FeedPage